import { Component } from '@angular/core';
import { CardModule } from 'primeng/card';
import { AuthService } from '../services/auth.service';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [CardModule, RouterModule, ButtonModule],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
  providers: [AuthService]
})
export class LoginPageComponent {
  constructor(private authService: AuthService) {}

  async login() {
    await this.authService.login();
  }
}
